module.exports = __webpack_public_path__ + "img/sham_wings.c9ab9807.png";